var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-container"},[_c('button',{staticClass:"border-button",on:{"click":_vm.getAstro}},[_vm._v(" Astronomical picture ")])])}
var staticRenderFns = []

export { render, staticRenderFns }